import React, { useState, useEffect } from 'react';
import { Box, Container, IconButton, Typography, Fab } from '@mui/material';
import { LinkedIn as LinkedInIcon, Instagram as InstagramIcon, Google as GoogleIcon, Twitter as TwitterIcon, Facebook as FacebookIcon, ArrowUpward as ArrowUpwardIcon } from '@mui/icons-material';

import { useThemeContextChange } from '../themeContext';

interface footerProps {
  className?: string;
}

const Footer: React.FC<footerProps> = ({ className }) => {
  const [showScroll, setShowScroll] = useState(false);

  const checkScrollTop = () => {
    if (!showScroll && window.pageYOffset > 400) {
      setShowScroll(true);
    } else if (showScroll && window.pageYOffset <= 400) {
      setShowScroll(false);
    }
  };

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    window.addEventListener('scroll', checkScrollTop);
    return () => {
      window.removeEventListener('scroll', checkScrollTop);
    };
  }, [showScroll]);

  const { footerBackgroundColor, footerTextColor,  footerButtonColor} = useThemeContextChange();

  return (
    <Box
    className={className}
      component="footer"
      sx={{
        textAlign: 'center',
        color: 'white',
        paddingTop: 5,
        position: 'relative',
        width:"100%",
        backgroundColor:footerBackgroundColor
      }}
    >
        <Container>
          <Box mb={4}>
            <IconButton
              sx={{ color: footerButtonColor, margin: 1 }}
            >
              <FacebookIcon fontSize="large" />
            </IconButton>
            <IconButton
              sx={{ color: footerButtonColor, margin: 1 }}
            >
              <TwitterIcon fontSize="large" />
            </IconButton>
            <IconButton
              sx={{ color: footerButtonColor, margin: 1 }}
            >
              <GoogleIcon fontSize="large" />
            </IconButton>
            <IconButton

              sx={{ color: footerButtonColor, margin: 1 }}
            >
              <InstagramIcon fontSize="large" />
            </IconButton>
            <IconButton
              sx={{ color: footerButtonColor, margin: 1 }}
            >
              <LinkedInIcon fontSize="large" />
            </IconButton>
            <Box>
              <Typography variant="caption" sx={{ marginTop: 2, color:footerTextColor }}>
                &copy; {new Date().getFullYear()} All rights reserved.
              </Typography>
            </Box>
          </Box>
        </Container>

      {showScroll && (
        <Fab
          color="primary"
          size="small"
          onClick={scrollTop}
          sx={{
            position: 'fixed',
            bottom: 16,
            right: 16,
            zIndex: 1000,
            backgroundColor: 'dark', 
            '&:hover': {
              backgroundColor: 'dark' 
            }
          }}
        >
          <ArrowUpwardIcon />
        </Fab>
      )}
    </Box>
  );
};

export default Footer;
